const AchievementObj ={
    "Hall of fames/ Appreceations/ Rewards":[
        {
            company_name:"Google",
            logo:require('../../images/Achievements/google.png'),
            hoflink:"https://bughunter.withgoogle.com/rank/hm/1"
        },
        {
            company_name:"OnePlus",
            logo:require("../../images/Achievements/oneplus.png"),
            hoflink:"https://security.oneplus.com/charts.html"
        },
        {
            company_name:"Fastmail",
            logo:require("../../images/Achievements/fastmail.png"),
            hoflink:"https://www.fastmail.com/about/bugbounty/"
        },
        {
            company_name:"Bizmerlin",
            logo:require("../../images/Achievements/bizmerlin.png"),
            hoflink:"https://www.bizmerlin.com/responsible-disclosure-policy/"
        },
        
        {
            company_name:"Vista",
            logo:require("../../images/Achievements/vista.png"),
            hoflink:"https://www.vista.co/responsible-disclosure-policy/"
        },
        {
            company_name:"Dutch Goverment",
            logo:require("../../images/Achievements/dutchgovt.png"),
            hoflink:""
        },
        
       
    ],
   

}

export default AchievementObj